var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditWorkSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H25C27.7614 0 30 2.23858 30 5V25C30 27.7614 27.7614 30 25 30H5C2.23858 30 0 27.7614 0 25V5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9232 8.88622L20.7695 7.73254C20.3008 7.2631 19.6652 7 19.002 7H9.37455C8.42515 7 7.65576 7.76939 7.65576 8.71879V20.2812C7.65576 21.2306 8.42515 22 9.37455 22H20.937C21.8864 22 22.6558 21.2306 22.6558 20.2812V10.6538C22.6558 9.99057 22.3927 9.35497 21.9232 8.88622ZM10.1557 10.9062V9.34375C10.1557 9.085 10.3657 8.875 10.6245 8.875H17.187C17.4457 8.875 17.6557 9.085 17.6557 9.34375V10.9062C17.6557 11.165 17.4457 11.375 17.187 11.375H10.6245C10.3657 11.375 10.1557 11.165 10.1557 10.9062ZM15.1558 19.5C13.6027 19.5 12.3433 18.2406 12.3433 16.6875C12.3433 15.1343 13.6027 13.875 15.1558 13.875C16.7088 13.875 17.9683 15.1343 17.9683 16.6875C17.9683 18.2406 16.7088 19.5 15.1558 19.5Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWorkSpace);
export default __webpack_public_path__ + "static/media/editWorkSpace.5d1f6ce0.svg";
export { ForwardRef as ReactComponent };